/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EntityModelProgramLocalizedTextDto } from '../models/EntityModelProgramLocalizedTextDto';
import type { EntityModelResponseContainerListProgramLocalizedTextDto } from '../models/EntityModelResponseContainerListProgramLocalizedTextDto';
import type { EntityModelResponseContainerProgramLocalizedTextDto } from '../models/EntityModelResponseContainerProgramLocalizedTextDto';
import type { PagedModelEntityModelProgramLocalizedTextDto } from '../models/PagedModelEntityModelProgramLocalizedTextDto';
import type { PagedResourcesAssemblerProgramLocalizedTextDto } from '../models/PagedResourcesAssemblerProgramLocalizedTextDto';
import type { ProgramLocalizedTextDto } from '../models/ProgramLocalizedTextDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DynamicLocalizedTextControllerService {
    /**
     * @returns PagedModelEntityModelProgramLocalizedTextDto OK
     * @throws ApiError
     */
    public static list({
        programId,
        assembler,
        keyStartsWith,
        page,
        size = 20,
        sort,
    }: {
        programId: number,
        assembler: PagedResourcesAssemblerProgramLocalizedTextDto,
        keyStartsWith?: string,
        /**
         * Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The size of the page to be returned
         */
        size?: number,
        /**
         * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         */
        sort?: Array<string>,
    }): CancelablePromise<PagedModelEntityModelProgramLocalizedTextDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/programs/{programId}/texts',
            path: {
                'programId': programId,
            },
            query: {
                'keyStartsWith': keyStartsWith,
                'page': page,
                'size': size,
                'sort': sort,
                'assembler': assembler,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static delete({
        programId,
        languageCode,
        messageKey,
    }: {
        programId: number,
        languageCode: string,
        messageKey: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/system/programs/{programId}/texts/codes/{languageCode}/keys/{messageKey}',
            path: {
                'programId': programId,
                'languageCode': languageCode,
                'messageKey': messageKey,
            },
        });
    }
    /**
     * @returns EntityModelProgramLocalizedTextDto OK
     * @throws ApiError
     */
    public static read({
        programId,
        languageCode,
        messageKey,
    }: {
        programId: number,
        languageCode: string,
        messageKey: string,
    }): CancelablePromise<EntityModelProgramLocalizedTextDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/programs/{programId}/texts/codes/{languageCode}/keys/{messageKey}',
            path: {
                'programId': programId,
                'languageCode': languageCode,
                'messageKey': messageKey,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerProgramLocalizedTextDto OK
     * @throws ApiError
     */
    public static create({
        programId,
        languageCode,
        messageKey,
        requestBody,
    }: {
        programId: number,
        languageCode: string,
        messageKey: string,
        requestBody: ProgramLocalizedTextDto,
    }): CancelablePromise<EntityModelResponseContainerProgramLocalizedTextDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/system/programs/{programId}/texts/codes/{languageCode}/keys/{messageKey}',
            path: {
                'programId': programId,
                'languageCode': languageCode,
                'messageKey': messageKey,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns EntityModelResponseContainerProgramLocalizedTextDto OK
     * @throws ApiError
     */
    public static update({
        programId,
        languageCode,
        messageKey,
        requestBody,
    }: {
        programId: number,
        languageCode: string,
        messageKey: string,
        requestBody: ProgramLocalizedTextDto,
    }): CancelablePromise<EntityModelResponseContainerProgramLocalizedTextDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/system/programs/{programId}/texts/codes/{languageCode}/keys/{messageKey}',
            path: {
                'programId': programId,
                'languageCode': languageCode,
                'messageKey': messageKey,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns EntityModelResponseContainerListProgramLocalizedTextDto OK
     * @throws ApiError
     */
    public static getAllLanguagesLocalizedMessages({
        programId,
        messageKey,
    }: {
        programId: number,
        messageKey: string,
    }): CancelablePromise<EntityModelResponseContainerListProgramLocalizedTextDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/system/programs/{programId}/texts/keys/{messageKey}',
            path: {
                'programId': programId,
                'messageKey': messageKey,
            },
        });
    }
}
